export const ERROR_TYPE_404 = 404
export const ERROR_TYPE_403 = 403
export const ERROR_TYPE_503 = 503
export const ERROR_TYPE_500 = 500
